// @flow
import * as React from 'react'
import type { School } from 'types'

type CtaData = {
  name: string,
  location: string,
  school?: School,
}

type ButtonType = 'button' | 'submit'
export type Appearance =
  | 'primary'
  | 'neutral'
  | 'danger'
  | 'naked'
  | 'pill'
  | 'link'
  | 'outlineBlue'
  | 'outlineWhite'
  | 'white'
  | 'black'
  | 'facebook'
  | 'twitter'
  | 'google'

export type Props = {
  className: string,
  type: ButtonType,
  block: boolean,
  disabled: boolean,
  fillParent: boolean,
  full: boolean,
  fullSmBreakpoint: boolean,
  large: boolean,
  cta: boolean,
  arrow: boolean,
  wrapText: boolean,
  square: boolean,
  appearance: Appearance,
  ctaData?: CtaData,
  onClick: (SyntheticEvent<HTMLButtonElement>) => void | (() => void),
  'data-pendo'?: string,
  children: React.Node,
}

export default class Button extends React.Component<Props> {
  static defaultProps = {
    className: 'Button',
    type: 'button',
    block: false,
    disabled: false,
    fillParent: false,
    full: false,
    fullSmBreakpoint: false,
    large: false,
    cta: false,
    arrow: false,
    wrapText: false,
    square: false,
    appearance: 'primary',
    onClick: () => undefined,
  }

  render = () => {
    return (
      <button
        className={this.className}
        type={this.props.type}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
        {...this.ctaDataProps}
        data-pendo={this.props['data-pendo']}
      >
        {this.props.children}
      </button>
    )
  }

  get ctaDataProps(): any {
    if (!this.props.ctaData) return undefined

    const data = {
      'data-cta-name': this.props.ctaData.name,
      'data-cta-location': this.props.ctaData.location,
    }

    if (this.props.ctaData.school) {
      return {
        ...data,
        'data-cta-school-name': this.props.ctaData.school.name,
        'data-cta-school-shortname': this.props.ctaData.school.shortname,
      }
    }

    return data
  }

  get className(): string {
    const className = this.props.className

    return [
      className,
      this.props.block ? `${className}--block` : '',
      this.props.fillParent ? `${className}--fillParent` : '',
      this.props.full ? `${className}--full` : '',
      this.props.fullSmBreakpoint ? `${className}--fullSmBreakpoint` : '',
      this.props.large ? `${className}--large` : '',
      this.props.cta ? `${className}--cta` : '',
      this.props.arrow ? `${className}--arrow` : '',
      this.props.wrapText ? `${className}--wrapText` : '',
      this.props.square ? `${className}--square` : '',
      this.appearanceClassNameModifier,
    ].join(' ')
  }

  get appearanceClassNameModifier(): string {
    if (!this.props.appearance) return ''

    const className = this.props.className

    return `${className}--${this.props.appearance}`
  }
}
